import { ref, onMounted, watch } from 'vue';

/**
 * Seeds a teammate's composer with the first message Flowie prepared, without
 * sending it. The user always sees and edits the draft before anything is
 * submitted, and an existing draft is never overwritten.
 *
 * @param {() => string} getInitialMessage Reader for the component's prop.
 * @param {import('vue').Ref<string>} messageInput The composer's model.
 */
export function useFlowieHandoff(getInitialMessage, messageInput) {
    const flowieComposerVisible = ref(false);

    onMounted(() => {
        const message = getInitialMessage();

        if (!message || messageInput.value) {
            return;
        }

        messageInput.value = message;
        flowieComposerVisible.value = true;
    });

    // The draft stops being Flowie's as soon as it is sent or cleared.
    watch(messageInput, (value) => {
        if (!value) {
            flowieComposerVisible.value = false;
        }
    });

    // Closing the handoff only removes the floating composer. The same draft
    // remains available in the teammate's regular composer underneath.
    const closeFlowieComposer = () => {
        flowieComposerVisible.value = false;
    };

    return { flowieComposerVisible, closeFlowieComposer };
}
